// built-in imports
import { FormattedMessage } from "react-intl";

// internal imports
import { Wrapper } from "./current-activity.component.styles";
import { HeartIcon } from "../index";
import { useAppContext } from "../../layout/layout";

const CurrentActivity = () => {
  const { lang } = useAppContext();
  return (
    <Wrapper>
      <h4>
        <FormattedMessage id="i.am.currently" defaultMessage="I am currently" />
      </h4>
      {lang === "en" && (
        <h4>
          <FormattedMessage id="learning" defaultMessage="learning" />
        </h4>
      )}
      <h4>
        <span>
          <FormattedMessage id="technology" defaultMessage="DevOps CI/CD" />
        </span>
      </h4>
      <HeartIcon />
    </Wrapper>
  );
};
export default CurrentActivity;
